/* eslint-disable no-plusplus */
/* eslint-disable indent */
import { defineStore, StateTree } from "pinia";
import PokerRunEventDataService from "@/services/PokerRunEventDataService";

export const useHomeStore = defineStore("home", {
  state: () => ({
    userPokerRunEvents: [],
    isOffline: false,
  }),
  actions: {
    setIsOffline(offline: boolean, profileId: string): void {
      if (this.isOffline !== offline) {
        this.isOffline = offline;
        if (!offline) {
          this.loadUserEvents(profileId);
        }
      }
    },
    async loadUserEvents(profileId: string): Promise<void> {
      if (this.isOffline) {
        this.setData(this.getData);
        return;
      }
      const items = await PokerRunEventDataService.getUserPokerRuns(profileId);
      this.userPokerRunEvents = items;
    },
    setData(data: any): void {
      this.userPokerRunEvents = data.userPokerRunEvents;
    },
  },
  getters: {
    getData(state): any {
      return {
        userPokerRunEvents: state.userPokerRunEvents,
      };
    },
  },
  persist: {
    afterRestore: (ctx) => {
      console.log(`just restored '${ctx.store.$id}'`)
      console.log(`just restored '${ctx.store.userPokerRunEvents.length}')}'`)
    }
  },
} as StateTree);
